import React, { useState } from "react";
import "./AppointmentModal.css";
import emailjs from "emailjs-com";

function AppointmentModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    date: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ===== VALIDATIONS =====
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValidPhone = (phone) =>
    /^[6-9]\d{9}$/.test(phone); // Indian 10-digit

  const isValidDate = (date) => {
    const selected = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selected >= today;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValidPhone(formData.phone)) {
      alert("Enter a valid 10-digit Indian mobile number");
      return;
    }

    if (!isValidEmail(formData.email)) {
      alert("Enter a valid email address");
      return;
    }

    if (!isValidDate(formData.date)) {
      alert("Please select today or a future date");
      return;
    }

    setLoading(true);

    emailjs
      .send(
        "service_tzfa8lj",
        "template_j1blu4r",
        formData,
        "8L5jExC6al9yUmudN"
      )
      .then(() => {
        setSubmitted(true);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to send appointment request");
        setLoading(false);
      });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      date: "",
      message: "",
    });
    setSubmitted(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        {/* ===== SUCCESS SCREEN ===== */}
        {submitted ? (
          <div className="success-box">
            <img src="/logo.png" alt="Hospital Logo" className="modal-logo" />
            <h2>Appointment Submitted 🎉</h2>
            <p>
              Thank you. Your appointment request has been successfully sent.
              Our team will contact you shortly.
            </p>

            <button
              className="modal-submit"
              onClick={resetForm}
            >
              Book Another Appointment
            </button>
          </div>
        ) : (
          <>
            <img src="/logo.png" alt="Hospital Logo" className="modal-logo" />
            <h2>Book an Appointment</h2>

            <form className="modal-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                className="modal-input"
                required
                onChange={handleChange}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Contact Number"
                className="modal-input"
                required
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                className="modal-input"
                required
                onChange={handleChange}
              />

              <label className="modal-label">Select Preferred Date</label>
              <input
                type="date"
                name="date"
                className="modal-input"
                required
                onChange={handleChange}
              />

              <textarea
                name="message"
                placeholder="Describe your issue"
                className="modal-textarea"
                rows="3"
                onChange={handleChange}
              ></textarea>

              <button type="submit" className="modal-submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default AppointmentModal;
